import { Tooltip, Typography } from "@material-ui/core";
import { formatDate, getErasureReportStatus } from "../../../../sc-utilities";
import React from "react";
import { formatProductTypes } from '../../../../sc-admin/SystemCertificate/utils';

export const singleTableColumns = (productTypes, translations, visible, createSingleAction, CustomChip) =>

    [
        {
            title: translations["action"] || 'Action', field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 200, maxWidth: 200 },
            filtering: false,
            render: rowData => {
                return <>
                    {createSingleAction(rowData, translations)}
                </>
            }
        },
        {
            title: translations['vendor'] || 'Vendor', field: 'Vendor',
            hidden: visible ? visible['Vendor'] : false,
            filtering: true,
            render: (rowData) => {
                return (
                    <>
                        { rowData.Product?.Vendor && rowData.Product.Vendor.length > 14 ? (
                            <Tooltip
                                key={`${rowData.ErasureReportID}`}
                                title={rowData.Product.Vendor}
                            >
                                <Typography variant={'caption'}>
                                    {rowData.Product.Vendor.slice(0, 13)}
                                </Typography>
                            </Tooltip>
                        ) : (
                            <Typography variant={'caption'}>
                                {rowData.Product?.Vendor ? rowData.Product.Vendor : translations['short_not_assigned'] || 'n/a'}
                            </Typography>
                        )}
                    </>
                );
            },
        },
        {
            title: translations['model'] || 'Model', field: 'Model',
            hidden: visible ? visible['Model'] : false,
            filtering: true,
            sorting: false,
            render: (rowData) => {
                return (
                    <Typography variant={'caption'}>
                        {rowData.Product?.PCProduct?.Name
                            ? rowData.Product.PCProduct.Name
                            : rowData.Product?.MobileProduct?.MobileProductModel
                                ? rowData.Product.MobileProduct.MobileProductModel
                                : translations['short_not_assigned'] || 'n/a'}
                    </Typography>
                );
            },
        },
        {
            title: translations["type"] || 'Type', field: 'ProductType',
            hidden: visible ? visible['ProductType'] : false,
            lookup: productTypes?.lookup,
            defaultFilter: productTypes?.defaultFilter,
            render: rowData => {
                return <Typography variant={'caption'}>{formatProductTypes(rowData?.Product?.Type, translations) || translations['short_not_assigned'] || 'n/a'}<br></br> </Typography>
            }
        },
        {
            title: translations['serial'] || 'Serial',
            field: 'ProductSerial',
            hidden: visible ? visible['ProductSerial'] : false,
            render: (rowData) => {
                return (
                    <Typography variant={'caption'}>
                        {rowData.Product?.SerialNumber ? rowData.Product.SerialNumber : translations['short_not_assigned'] || 'n/a'}
                    </Typography>
                );
            },
            cellStyle: {
                width: 120,
                minWidth: 120,
            },
            headerStyle: {
                width: 120,
                minWidth: 120,
            }
        },
        {
            title: 'IMEI', field: 'IMEI',
            hidden: visible ? visible['IMEI '] : false,
            filtering: true,
            sorting: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Product?.MobileProduct?.IMEI || translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: 'IMEI2', field: 'IMEI2',
            hidden: visible ? visible['IMEI2 '] : true,
            filtering: true,
            sorting: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Product?.MobileProduct?.IMEI2 || translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["username"] || 'Username', field: 'Username',
            hidden: visible ? visible['Username'] : true,
            cellStyle: { minWidth: 220, maxWidth: 220 },
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.User && rowData.User.Username ? rowData.User.Username : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["status"] || 'Status', field: 'GeneratedStatus',
            hidden: visible ? visible['GeneratedStatus'] : false,
            lookup: { '0': translations['ready_to_generate'] || 'Ready to generate', '1': translations['in_progress'] || "In progress", '2': translations['generated'] || 'Generated', '-1': translations['failed'] || 'Failed' },
            defaultFilter: ['0', '1', '2', '-1'],
            filtering: true,
            sorting: false,
            width: 100,
            render: rowData => {
                return <CustomChip trimming={true} customChipKey={rowData.ColliInventoryID}
                    className={`chip${getErasureReportStatus(rowData.GeneratedStatus, 'forStyle')}`}
                    value={getErasureReportStatus(rowData.GeneratedStatus, rowData.Generated, rowData.ToGenerate, translations)} />
            }
        },
        {
            title: translations["file_name"] || 'File Name', field: 'OriginalFileName',
            hidden: visible ? visible['OriginalFileName'] : true,
            filtering: true,
            selection: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.OriginalFileName ? rowData.OriginalFileName : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["number_of_downloads"] || 'Number of downloads', field: 'DownloadedNumber',
            hidden: visible ? visible['DownloadedNumber'] : true,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.DownloadedNumber ? rowData.DownloadedNumber : '0'}</Typography>;
            }
        },
        {
            title: translations["requested_at"] || 'Requested at', field: 'RequestedAt',
            hidden: visible ? visible['RequestedAt'] : false,
            filtering: true,
            sorting: true,
            type: 'date',
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.RequestedAt ? formatDate(rowData.RequestedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
    ]